import { useCallback, useEffect, useState } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";
import { useIsLoginDisabled } from "CrossFeatureComponents/MemberToolbar/stateHooks";
import { usePostTwoFactorAuth } from "Login/TwoFA/API/queries";

import { ButtonWrapper } from "../../shared";

import ButtonDisplay from "./ButtonDisplay";
import { useIsActive } from "./stateHooks";

const LoginButton = () => {
  const { loginVariant, tabID, remoteCancelLoginRef, loginButtonRef } =
    useMemberToobarContext();
  const { setActiveContentKey } = useMemberToolbarStore();
  const isLoginDisabled = useIsLoginDisabled();
  const isActive = useIsActive();

  const [shouldFetch, setShouldFetch] = useState(false);
  const [shouldOpenOnLoad, setShouldOpenOnLoad] = useState(false);
  const { isFetching } = usePostTwoFactorAuth({
    postData: shouldFetch ? { tabID } : false,
    variant: loginVariant,
  });

  const toggleActiveKey = useCallback(() => {
    if (!shouldFetch) {
      setShouldFetch(true);
      setShouldOpenOnLoad(true);
      return;
    }
    if (isActive) {
      setActiveContentKey(contentKeys.nothing);
      if (typeof remoteCancelLoginRef.current === "function")
        remoteCancelLoginRef.current();
    } else setActiveContentKey(contentKeys.login);
  }, [isActive, remoteCancelLoginRef, setActiveContentKey, shouldFetch]);

  useEffect(() => {
    if (shouldFetch && !isFetching && shouldOpenOnLoad) {
      setActiveContentKey(contentKeys.login);
      setShouldOpenOnLoad(false);
    }
  }, [isFetching, shouldFetch, shouldOpenOnLoad, setActiveContentKey]);

  return (
    <SButtonWrapper
      onClick={toggleActiveKey}
      data-cy="MemberToolbar_LoginButton"
      disabled={isLoginDisabled}
      DisplayComponent={ButtonDisplay}
      displayComponentProps={{ isLoading: isFetching && shouldOpenOnLoad }}
      isActive={isActive}
      ref={loginButtonRef}
    />
  );
};

const SButtonWrapper = styled(ButtonWrapper)`
  display: flex;
  align-items: center;
`;

export default LoginButton;
